// extracted by mini-css-extract-plugin
export default {"page":"kx66Thjf","wrapper":"AEdEToDK","form":"Uap9G39D","avatarList":"HUkhJtTP","avatarItem":"Klf2iaKp","active":"q_KNjT6A"};
    if(module.hot) {
      // 1721069998905
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  